import React, { useState } from "react";
import { Box } from "@mui/material";
import { ButtonV1 } from "components";

const RecipientWrapper = ({ firstRecipient, totalCount, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen((prev) => !prev);

  return (
    <Box
      display="flex"
      flexDirection={isOpen ? "column" : "row"}
      alignItems={isOpen ? "flex-start" : "baseline"}
      gap={2}
      width={"100%"}
    >
      {isOpen ? <>{children}</> : <>{firstRecipient}</>}

      {totalCount > 1 && (
        <ButtonV1
          variant="text"
          onClick={handleToggle}
          title={isOpen ? "show less" : `+${totalCount - 1} more`}
          style={{ padding: 0, minWidth: "unset" }}
          boxStyle={{ justifyContent: "flex-start", width: "100%" }}
        />
      )}
    </Box>
  );
};

export default RecipientWrapper;
